export default __webpack_public_path__ + "static/media/Mechno-Leg-01.d83b367c.jpg";